import Col from "react-bootstrap/Col";
import { useAppSelector } from "../../services/hooks";
import { Button, Carousel, Image } from "react-bootstrap";
import { useRef, useState } from "react";
import LightboxGallery from "../../components/LightBoxGallery/LightBoxGallery";

export default function ProductImage() {
    const name = useAppSelector((state) => state.product.data.name)

    return (
        <Col xs={{ span: 12, order: 0 }} md={8} lg={{ order: 0 }} xl={{ order: 0 }} className="text-center">
            <h1 className="text-center my-3 mt-md-0">{name}</h1>
            <GalleryOrMain />
        </Col>
    )
}

function GalleryOrMain() {
    const [index, setIndex] = useState(0);
    const [open, setOpen] = useState(false);
    const imgUrl = useAppSelector((state) => state.product.data.image?.main)
    const gallery = useAppSelector((state) => state.product.data.image?.gallery)
    const scrollRef = useRef<HTMLDivElement>(null);
    const defaultImage = '/tpl/assets/img/RomerProductFoto.png';

    const scrollRight = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollLeft += 300; // przesuń o 300px w prawo
        }
    };

    const scrollLeft = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollLeft -= 300; // przesuń o 300px w lewo
        }
    };

    if (!gallery || gallery.length === 0)
        return (
            <div className="w-75 mx-auto text-center">
                <img src={imgUrl ? `/products/mini_karta/${imgUrl}` : defaultImage} className="img-fluid rounded-4" alt="Product image" />
            </div>
        )
    else {
        const slides = new Array(...gallery)
        slides.push({ src: imgUrl, alt: "asd" })
        slides.reverse()

        const showCarouselItems = slides.map((slide, index) => (
            <Carousel.Item key={index}>
                <img src={slide.src ? `/products/mini_karta/${slide.src}` : defaultImage} onClick={() => setOpen(true)} style={{ cursor: 'zoom-in' }} className="img-fluid rounded-4" alt="Product image" />
            </Carousel.Item>
        ))

        return (<>
            {gallery &&
                <div className=" w-75 mx-auto text-center">
                    <Carousel prevIcon={<i className="bi bi-arrow-left-square fs-1 text-success" />} nextIcon={<i className="bi bi-arrow-right-square fs-1 text-success" />} indicators={false} activeIndex={index} onSelect={(idx) => setIndex(idx)}>
                        {showCarouselItems}
                    </Carousel>
                    <div className="d-flex pt-2">
                        <Button variant="" onClick={scrollLeft} ><i className="bi bi-arrow-left" /></Button>
                        <div ref={scrollRef} className="d-flex overflow-x-scroll hideScroll w-auto" style={{ scrollBehavior: "smooth" }}>
                            {slides.map((slide, idx) => (
                                <Image
                                    key={idx}
                                    src={slide.src ? `/products/mini_karta/${slide.src}` : defaultImage}
                                    thumbnail
                                    onClick={() => setIndex(idx)}
                                    className={idx === index ? 'border-3 border-secondary' : ''}
                                    style={{ cursor: 'pointer', width: '75px', height: '75px', objectFit: 'cover' }}
                                />
                            ))}
                        </div>
                        <Button variant="" onClick={scrollRight} ><i className="bi bi-arrow-right" /></Button>
                    </div>
                    <LightboxGallery slides={slides} open={open} setOpen={setOpen} />
                </div>
            }
        </>)
    }
}